import { useCallback, useRef, useState } from "react";
import { toast } from "sonner";

// Drag-and-drop image files onto any upload box. onFiles receives the dropped image File[].
// Only reacts to OS file drags (not in-app thumbnail drags), so existing drag-assign flows keep working.
export const useImageDrop = (onFiles) => {
  const [dragging, setDragging] = useState(false);
  const depth = useRef(0);
  const isFileDrag = (e) => Array.from(e.dataTransfer?.types || []).includes("Files");
  const onDragEnter = useCallback((e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    e.stopPropagation();
    depth.current += 1;
    setDragging(true);
  }, []);
  const onDragOver = useCallback((e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
  }, []);
  const onDragLeave = useCallback((e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    e.stopPropagation();
    depth.current = Math.max(0, depth.current - 1);
    if (depth.current === 0) setDragging(false);
  }, []);
  const onDrop = useCallback((e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    e.stopPropagation();
    depth.current = 0;
    setDragging(false);
    const images = Array.from(e.dataTransfer.files || []).filter((f) => f.type.startsWith("image/"));
    if (!images.length) { toast.error("Please drop image files only"); return; }
    onFiles(images);
  }, [onFiles]);
  return { dragging, dropProps: { onDragEnter, onDragOver, onDragLeave, onDrop } };
};

export const dropRingClass = (dragging, base = "") => `${base} ${dragging ? "ring-2 ring-red-500 ring-offset-2 rounded bg-red-50/60" : ""}`.trim();
